<template>
  <div class="dicButton">
    <el-button
      type="text"
      size="middle"
      v-has-permission="permission"
      :title="text"
      @click="buttonClick"
    >
      <i :class="icon" class="iconfont" />
    </el-button>
  </div>
</template>
<script>
export default {
  props: {
    icon: {
      type: String
    },
    text: {
      type: String
    },
    permission: {
      type: String
    }
  },

  methods: {
    buttonClick() {
      this.$emit('buttonClick')
    }
  }
}
</script>

<style lang="less" scoped>
.el-button,
.el-button:hover,
.el-button:active {
  color: #333333 !important;
  i {
    font-size: 16px;
  }
  .icon-jr-icon-modify {
    color: #17757a;
  }
  .icon-jr-icon-delete {
    color: #ff6c66;
  }
}
.el-button--text:focus {
  border: 1px solid #fff !important;
}
.el-button--text:hover {
  border: 1px solid #fff !important;
}
</style>
